import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

// Staff inbox: same filters as /app/inbox but with an extra client_id
// dimension so a staff member can scope the view to a single tenant.
export const Route = createFileRoute("/admin/inbox/")({
  validateSearch: z.object({
    status: z.string().optional(),
    owner_user_id: z.string().optional(),
    q: z.string().optional(),
    segment_id: z.string().optional(),
    client_id: z.string().optional(),
  }),
});
